
import {
  computed, defineComponent, reactive, ref,
} from 'vue';
import draggable from 'vuedraggable';
import Icone from '@/core/components/UI/Icone.vue';
import { ICaracteristicaItem } from '@/models/Entidades/ICaracteristica';
import SelecionarSimNao from '@/core/components/UI/SelecionarSimNao.vue';
import MensagemSemDados from '@/core/components/UI/MensagemSemDados.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { useAppBase } from '@/core/composables/AppBase';

export default defineComponent({
  name: 'ItensCores',
  emits: ['update:itensCores'],
  props: {
    codigoCaracteristica: {
      type: Number,
      required: true,
    },
    itensCores: {
      type: Array as () => ICaracteristicaItem[],
      required: true,
    },
  },
  components: {
    draggable,
    Icone,
    SelecionarSimNao,
    MensagemSemDados,
  },
  setup(props, { emit }) {
    const { apresentarMensagemAlerta } = useAppBase();

    const campoNovoValorItem = ref<HTMLElement | null>(null);

    const state = reactive({
      novoValor: '',
      novaCor: '#FFF',
    });

    const computedItensCores = computed({
      get: () => props.itensCores,
      set: (val: ICaracteristicaItem[]) => {
        emit('update:itensCores', val);
      },
    });

    function removerItem(index:number) {
      computedItensCores.value.splice(index, 1);
    }

    function defineFocoCampoNovoItem() {
      if (campoNovoValorItem.value) {
        campoNovoValorItem.value.focus();
      }
    }

    function adicionarItem() {
      if (!UtilitarioGeral.valorValido(state.novoValor)) {
        apresentarMensagemAlerta('Por favor, defina um nome para a cor!');
        defineFocoCampoNovoItem();
        return;
      }

      const itens = computedItensCores.value;
      const itemCaracteristica:ICaracteristicaItem = {} as ICaracteristicaItem;
      itemCaracteristica.codigo = 0;
      itemCaracteristica.codigoCaracteristica = props.codigoCaracteristica;
      itemCaracteristica.valor = state.novoValor;
      itemCaracteristica.apresentacao = state.novaCor;
      itemCaracteristica.status = true;
      itens.push(itemCaracteristica);
      state.novoValor = '';
      state.novaCor = '#FFF';
      emit('update:itensCores', itens);
    }

    return {
      state,
      computedItensCores,
      campoNovoValorItem,
      removerItem,
      adicionarItem,
    };
  },
});
